module.exports = __webpack_public_path__ + "static/media/export-csv-Grey.2117a438.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/export-csv-Grey.svg
// module id = 1611
// module chunks = 1